import './Skeleton.css'

interface SkeletonProps {
  width?: string | number
  height?: string | number
  variant?: 'text' | 'circular' | 'rectangular'
  className?: string
  lines?: number
  style?: React.CSSProperties
}

function toCssValue(v: string | number): string {
  return typeof v === 'number' ? `${v}px` : v
}

export function Skeleton({
  width,
  height,
  variant = 'rectangular',
  className = '',
  lines = 1,
  style: propStyle
}: SkeletonProps) {
  const heightCss = height ? toCssValue(height) : undefined
  const defaultStyle: React.CSSProperties = {
    width: width ? toCssValue(width) : '100%',
    height: heightCss,
    minHeight: heightCss ?? undefined,
  }

  const combinedStyle = { ...defaultStyle, ...propStyle }

  if (variant === 'text' && lines > 1) {
    return (
      <div className={`skeleton skeleton--text ${className}`}>
        {Array.from({ length: lines }).map((_, i) => (
          <div
            key={i}
            className="skeleton__line"
            style={{
              ...combinedStyle,
              width: i === lines - 1 ? '60%' : '100%',
              marginBottom: i < lines - 1 ? '8px' : '0',
            }}
          />
        ))}
      </div>
    )
  }

  return (
    <div
      className={`skeleton skeleton--${variant} ${className}`}
      style={combinedStyle}
    />
  )
}

/** 리스트 아이템 스켈레톤: 이미지 영역 고정 크기 + 텍스트 라인. 로딩 시 레이아웃 밀림 방지 */
interface SkeletonListItemProps {
  imageSize?: number
  lines?: number
  className?: string
  style?: React.CSSProperties
}

export function SkeletonListItem({
  imageSize = 56,
  lines = 2,
  className = '',
  style
}: SkeletonListItemProps) {
  return (
    <div className={`skeleton-list-item ${className}`} style={style}>
      <div
        className="skeleton-list-item__image"
        style={{
          width: imageSize,
          minWidth: imageSize,
          height: imageSize,
          minHeight: imageSize,
        }}
      />
      <div className="skeleton-list-item__body">
        {Array.from({ length: lines }).map((_, i) => (
          <div
            key={i}
            className={`skeleton-list-item__line ${i === lines - 1 && lines > 1 ? 'skeleton-list-item__line--short' : ''}`}
          />
        ))}
      </div>
    </div>
  )
}

export default Skeleton

